import { HStack, Text } from "@chakra-ui/react";
import { toDisplayText } from "../../../../utils/localizedText";

const formatValueCell = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "string" && value.trim().endsWith("%")) return value;

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) return String(value);

  return numericValue.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const AnalyticalLayerNode = ({ isArabic, node, onToggle }) => {
  const hasChildren = Array.isArray(node.children) && node.children.length > 0;
  const padding = `${5 + (node.level || 0) * 10}px`;
  const values = Array.isArray(node.values) ? node.values : ["", "", ""];

  return (
    <>
      <tr
        style={{ cursor: hasChildren ? "pointer" : "default" }}
        onClick={hasChildren ? () => onToggle(node.id) : undefined}
      >
        <td
          style={{
            padding: "5px 6px",
            paddingInlineStart: isArabic ? undefined : padding,
            paddingInlineEnd: isArabic ? padding : undefined,
            position: "sticky",
            left: 0,
            zIndex: 1,
            background: "#ffffff",
            minWidth: "300px",
            width: "300px",
          }}
        >
          <HStack spacing={1}>
            {hasChildren && (
              <Text color="#F9A825">{node.isOpen ? "▼" : "▶"}</Text>
            )}
            <Text>{toDisplayText(node.label, node.id)}</Text>
          </HStack>
        </td>
        {values.map((value, index) => (
          <td
            key={`${node.id}-${index}`}
            style={{
              padding: "5px 6px",
              textAlign: isArabic ? "left" : "right",
              color:
                typeof value === "number" && value < 0 ? "#dc3545" : "#333333",
            }}
          >
            {formatValueCell(value)}
          </td>
        ))}
      </tr>
      {hasChildren && node.isOpen
        ? node.children.map((child) => (
            <AnalyticalLayerNode
              key={child.id}
              isArabic={isArabic}
              node={child}
              onToggle={onToggle}
            />
          ))
        : null}
    </>
  );
};
